export default "__VITE_ASSET__CdnetTLk__"